import { render } from "./InvitationDialog.vue?vue&type=template&id=e4af7cde&scoped=true"
import script from "./InvitationDialog.vue?vue&type=script&lang=js"
export * from "./InvitationDialog.vue?vue&type=script&lang=js"

import "./InvitationDialog.vue?vue&type=style&index=0&id=e4af7cde&scoped=true&lang=css"

import exportComponent from "D:\\project2025\\green-lit-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4af7cde"]])

export default __exports__